import { configureStore } from "@reduxjs/toolkit";
import languageSlice from "./language-slice";

export const store = configureStore({
  reducer: {
    languageTranslation: languageSlice.reducer,
  },
});

export default store;
